<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">فرم ویرایش اطلاعات واحد </h5>
    <form [formGroup]="EditUnit" (submit)="SubmitEditUnit()">

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> کمیت </label>
          <input type="text" class="form-control" disabled value="{{Data_Seleted_Record.title}}" />
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">عنوان</label>
          <input formControlName="Title" type="text" style="font-family: Arial, Helvetica, sans-serif;"
            class="form-control EnglishClm" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_Title().valid && get_Form_Title().touched"
            class="form-text text-muted MyErrorRedColor">عنوان را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-4" >
          <label for="exampleInputEmail1">پیش نمایش</label>
          <div style="font-weight: bold;font-size: 30px;" innerHTML="{{get_Form_Title().value}}"></div>
        </div>
      </div>
      <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!InProccessing" type="submit" [disabled]="!EditUnit.valid" class="btn btn-success"
        style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
      <button routerLink="/Unit" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i
          class="fa fa-mail-reply"></i> بازگشت </button>
    </form>
  </div>
</div>